import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';

import { AsyncJobConfig } from '../../async-job-view.types';

@Injectable()
export class BulkReferralApplicationsAcceptAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BulkReferralApplicationsAccept;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.bulk_referral_applications_accept.title.success',
      progress: 'app.async_jobs.bulk_referral_applications_accept.title.progress',
    },
  };

  public readonly skipNotificationMessages = true;
}
